module.exports = (__webpack_require__(0))(317);


//////////////////
// WEBPACK FOOTER
// delegated ./src/templates/widgets/jsonMetadatumEditWidget.pug from dll-reference girder_lib
// module id = 163
// module chunks = 0